import React from "react";

import { BreakpointProvider } from "@utils/breakpoints/breakpoints.provider";
import { ProductImageRenditions } from "@utils/enums";

import { ProductImageWrapper } from "@components/Product/ProductImage/productImage.component";

import { Renditions } from "./mappedRenditions";
import { Media } from "lib/@types/service/shared";

type Props = {
    title: string | undefined;
    medias?: null | Array<Media>;
    rendition?: ProductImageRenditions;
    renditions?: Renditions;
    isEcoChequesAccepted: boolean;
    className?: string;
    lazyLoad?: boolean;
    parentFit?: boolean;
};

const ProductImageContainer = ({
    title,
    medias,
    renditions,
    isEcoChequesAccepted,
    className,
    lazyLoad = false,
    parentFit = false,
}: Props) => {
    if (!medias || medias.length === 0) {
        return <></>;
    }

    return (
        <BreakpointProvider>
            <ProductImageWrapper
                title={title}
                medias={medias}
                renditions={renditions}
                isEcoChequesAccepted={isEcoChequesAccepted}
                className={className}
                lazyLoad={lazyLoad}
                parentFit={parentFit}
            />
        </BreakpointProvider>
    );
};

export { ProductImageContainer };
